import { Stack } from '@mui/material';
import {
  StyledAlbumArtistTypography,
  StyledAlbumBox,
  StyledAlbumGrid,
  StyledAlbumTitleTypography,
  StyledAlbumYearTypography,
  StyledBox,
  StyledHeaderTypography,
  StyledMusicStack,
} from './music.styles';
import { OTHER, SOLO_ALBUMS, SUNJACKET_ALBUMS } from './music.const';

type Album = {
  title: string;
  artist: string;
  year: string;
  imageSrc: string;
  url?: string;
};

interface AlbumSectionProps {
  title: string;
  albums: Album[];
}

const AlbumSection = ({ title, albums }: AlbumSectionProps) => (
  <Stack spacing={2}>
    <StyledHeaderTypography>{title}</StyledHeaderTypography>
    <StyledAlbumGrid>
      {albums.map((album) => (
        <StyledAlbumBox
          key={album.title}
          component={album.url ? 'a' : 'div'}
          href={album.url || undefined}
          target={album.url ? '_blank' : undefined}
          rel={album.url ? 'noopener noreferrer' : undefined}
          sx={{ cursor: album.url ? 'pointer' : 'default' }}
        >
          <img src={album.imageSrc} alt={`${album.title} cover`} loading="lazy" />
          <div className="album-overlay">
            <StyledAlbumArtistTypography>{album.artist}</StyledAlbumArtistTypography>
            <StyledAlbumTitleTypography>{album.title}</StyledAlbumTitleTypography>
            <StyledAlbumYearTypography>{album.year}</StyledAlbumYearTypography>
          </div>
        </StyledAlbumBox>
      ))}
    </StyledAlbumGrid>
  </Stack>
);

export const Music = () => {
  return (
    <StyledBox id="music">
      <StyledMusicStack spacing={4}>
        <AlbumSection title="Solo Albums" albums={SOLO_ALBUMS} />
        <AlbumSection title="Sunjacket" albums={SUNJACKET_ALBUMS} />
        <AlbumSection title="Other" albums={OTHER} />
      </StyledMusicStack>
    </StyledBox>
  );
};
